import Icon from "components/Elements/Icon/Icon.tsx";
import Image from "components/Elements/Image/Image.tsx";
import { useContent } from "contexts/contentContext/contentContext.js";
import { ContactEditImageComponent } from "./ContactEditImageComponent.tsx";
import config from "config.ts";
import { contactFormFields } from "./contactFormFields.tsx";
import Form from "components/Reusable/Form/Form.js";

export const ContactElementModal = ({
  isEdit,
  details,
  countFavoritesUsers,
  handleSubmit,
  fromSearch = null,
  setContactList,
}) => {
  const { getTextByKey } = useContent();
  const defaultAvatar = "avatar_default_large";

  const saveDetails = (body) =>
    handleSubmit(body, fromSearch ? details : undefined);

  return (
    <div className="contact-element-modal-container">
      {isEdit && (
        <div className="profile-avatar">
          {details?.contact_list_favorite && (
            <div className="favorite-contact">
              <Icon name="star-solid" />
            </div>
          )}
          <div className="profile-img-text">
            {details?.contact_list_image ? (
              <>
                <Image
                  src={details?.contact_list_image}
                  name={!details?.contact_list_image ? defaultAvatar : null}
                  //@ts-ignore
                  ext={!details?.contact_list_image && "png"}
                />
                <ContactEditImageComponent
                  {...{ setContactList, details, getTextByKey }}
                />
              </>
            ) : (
              <>
                <Image
                  src={`${config.api.resource}/assets/images/avatar_default_large.png`}
                  name={!details?.contact_list_image ? defaultAvatar : null}
                  //@ts-ignore
                  ext={!details?.contact_list_image && "png"}
                />
                <ContactEditImageComponent
                  {...{ setContactList, details, getTextByKey }}
                />
              </>
            )}
          </div>
        </div>
      )}
      <Form
        //@ts-ignore
        onSubmit={saveDetails}
        fields={contactFormFields}
        fieldsProps={{ label: "hidden", field: "square" }}
        submitProps={{
          title: getTextByKey("save"),
          className: "new-button",
        }}
        defaultValuesObj={
          details
            ? {
                ContactName: details.contact_list_full_name,
                Email: details.contact_list_email,
                PhoneNumber: details.contact_list_phone,
                ContactListFavorite: details.contact_list_favorite,
              }
            : {}
        }
        externalProps={{
          countFavoritesUsers,
        }}
      />
    </div>
  );
};
